import api from '../api/api'

/**
 * Check if user has a saved location (works for anonymous too)
 */
export const checkLocationStatus = async () => {
  const res = await api.get('/auth/location/status')
  return res.data
}

/**
 * Set / update user's current location (upsert)
 */
export const setUserLocation = async locationData => {
  const res = await api.post('/auth/location/set', locationData)
  return res.data
}

/**
 * Get user's current saved location
 */
export const getUserLocation = async () => {
  const res = await api.get('/auth/location')
  return res.data
}

/**
 * Set location from a saved delivery address
 */
export const setLocationFromAddress = async addressId => {
  const res = await api.post('/auth/location/from-address', { address_id: addressId })
  return res.data
}

/**
 * Browse vendors filtered by proximity
 */
export const getVendorsProximity = async (params = {}) => {
  const query = new URLSearchParams()
  if (params.lat) query.set('lat', params.lat)
  if (params.lng) query.set('lng', params.lng)
  if (params.radius) query.set('radius', params.radius)
  if (params.page) query.set('page', params.page)
  if (params.category && params.category !== 'all') query.set('category', params.category)
  if (params.search) query.set('search', params.search)
  const qs = query.toString()
  const res = await api.get(`/auth/vendors${qs ? `?${qs}` : ''}`)
  return res.data
}

/**
 * Preview delivery fee calculation
 */
export const calculateDeliveryFee = async ({ customerLat, customerLng, vendorId }) => {
  const res = await api.post('/orders/delivery/calculate/', {
    customer_latitude: customerLat,
    customer_longitude: customerLng,
    vendor_id: vendorId
  })
  return res.data
}
